module.exports = __webpack_public_path__ + "static/media/jc_camera_icon.807312ea.svg";